// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__22Nim","productName":"Table_productName__39wbN"};